import { render, staticRenderFns } from "./policyData.vue?vue&type=template&id=efc517da&"
import script from "./policyData.vue?vue&type=script&lang=js&"
export * from "./policyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports